export const COOKIE_DOMAIN_QUERY_PARAM = 'orCookieDomain';

export function getCookieDomainFromQuery(
  location: Location | string = typeof window !== 'undefined' ? window.location.href : '',
) {
  if (!location) {
    return null;
  }

  const url = typeof location === 'string' ? new URL(location) : new URL(location.href);
  return url.searchParams.get(COOKIE_DOMAIN_QUERY_PARAM);
}
